import React from "react";
import CountUp from "react-countup";

import bg from "../../img/about-bg.png";
import img1 from "../../img/about-1.png";
import img2 from "../../img/about-2.png";
import signature from "../../img/signature.png";
import { withTranslation } from 'react-i18next';

import "./style.css";

const About = ({ t }) => {
  return (
    <section className="about-area" style={{ backgroundImage: `url(${bg})` }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6">
            <div className="about-left" data-aos="fade-right">
              <div className="site-heading">
                <h3 className="sub-title">{t('Header.Aboutus')}</h3>
              </div>
              <p>{t('Home.about_1')}</p>
              <p>{t('Home.about_2')}</p>
              <p>{t('Home.about_3')}</p>
              <div className="about-signature">
                <div className="signature-left">
                  <a href="https://dessinsdrummond.com/" target="_blank" rel="noopener noreferrer">
                    <img src={signature} alt="signature" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1 col-md-6">

            <div className="about-right" data-aos="fade-left">
              <img className="about_img_1" src={img2} alt="img" />
              <img className="about_img_2" src={img1} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withTranslation()(About);
